/**
 * Before / After Comparison Slider — JavaScript
 *
 * A draggable vertical divider reveals a "normal" (no-extensions) image
 * behind the selected variant (with-extensions) image.  Variant tab buttons
 * let the user switch which hair-length variant is shown.
 *
 * Reads `data-base-url` from the section container to construct Shopify Files
 * CDN image URLs.
 */
(function () {
  'use strict';

  function initCompareSlider(section) {
    var baseUrl = section.dataset.baseUrl;
    if (!baseUrl) return;

    var slider   = section.querySelector('.compare-slider');
    var reveal   = section.querySelector('.compare-reveal');
    var handle   = section.querySelector('.compare-handle');
    var beforeImg = section.querySelector('.compare-before');
    var afterImg  = section.querySelector('.compare-after');
    var buttons   = section.querySelectorAll('.compare-variant-btn');

    if (!slider || !reveal || !handle || !beforeImg || !afterImg) return;

    /* ── Keep after image sized to slider full width ──────────────────── */
    function syncAfterWidth() {
      afterImg.style.width = slider.offsetWidth + 'px';
    }
    syncAfterWidth();
    window.addEventListener('resize', syncAfterWidth);

    /* ── Variant button clicks ───────────────────────────────────────── */
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var prefix = btn.dataset.prefix;
        var imageUrl = btn.dataset.imageUrl;

        if (imageUrl) {
          beforeImg.src = imageUrl;
        } else if (prefix) {
          beforeImg.src = baseUrl + prefix + '001.jpg';
        }

        buttons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });

    /* ── Slider drag logic ───────────────────────────────────────────── */
    var dragging = false;

    function setPosition(x) {
      var rect = slider.getBoundingClientRect();
      var pct = ((x - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      reveal.style.width = pct + '%';
      handle.style.left  = pct + '%';
    }

    slider.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      dragging = true;
      slider.setPointerCapture(e.pointerId);
      setPosition(e.clientX);
    });

    slider.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      setPosition(e.clientX);
    });

    slider.addEventListener('pointerup',     function () { dragging = false; });
    slider.addEventListener('pointercancel',  function () { dragging = false; });
  }

  /* ── Bootstrap ─────────────────────────────────────────────────────── */

  function boot() {
    document.querySelectorAll('.compare-section').forEach(initCompareSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
